import * as filterOptions from '../filterOptions';
import algoliaApi from '../../services/algolia-api';

export default {
  age: {
    id: 'age',
    isMulti: true,
    label: 'Age Group of Fans',
    options: filterOptions.age,
    value: null
  },
  country: {
    id: 'country',
    isMulti: true,
    label: 'Country',
    options: filterOptions.country,
    value: null
  },
  contentType: {
    id: 'contentType',
    label: 'Content Type',
    options: filterOptions.contentType,
    value: null
  },
  originating_country: {
    id: 'originating_country',
    isMulti: true,
    label: 'Originating Country',
    options: filterOptions.country,
    value: null
  },
  language: {
    id: 'originating_language',
    isMulti: true,
    label: 'Originating Language',
    options: filterOptions.language,
    value: null
  },
  sampleBalance: {
    id: 'panel',
    label: 'Panel',
    options: filterOptions.sampleBalance,
    value: { value: 'Yes', label: 'Balanced' },
    tooltip: {
      showOnValues: ['Yes'],
      text:
        "A balanced panel resolves modest variances between the sample population and a country's census reported population by adjusting relative weights of individuals according to their age (18-54) and gender profile. Data is balanced within country only.",
      placement: 'top'
    }
  },
  date: {
    id: 'date',
    isDate: true,
    label: 'Date Range',
    options: filterOptions.dateRange,
    value: null
  },
  followers: {
    id: 'followers',
    title: 'Followers',
    isMulti: true,
    label: 'Followers',
    options: filterOptions.followers,
    value: null
  },
  days_from_release: {
    id: 'days_from_release',
    label: 'Days from Release',
    options: filterOptions.daysFromRelease,
    value: null
  },
  first_release_date: {
    id: 'first_release_date',
    isDate: true,
    isNumericDate: true,
    label: 'First Release Date',
    options: filterOptions.dateRange,
    value: null
  },
  release_date: {
    id: 'release_date',
    isDate: true,
    isNumericDate: true,
    label: 'Release Date',
    options: filterOptions.dateRange,
    value: null
  },
  report_date: {
    id: 'report_date',
    isDate: true,
    label: 'Report Date',
    options: filterOptions.dateRange,
    value: null
  },
  future_release_date: {
    id: 'future_release_date',
    isDate: true,
    label: 'Release Date',
    options: filterOptions.futureDateRange,
    value: null,
    isFuture: true
  },
  genre: {
    id: 'genre',
    isMulti: true,
    label: 'Genre',
    options: filterOptions.genre,
    value: null
  },
  network: {
    id: 'network',
    isAsync: true,
    isMulti: true,
    label: 'Network',
    loadOptions: algoliaApi.getNetworkFilterOptions,
    value: null
  },
  gender: {
    id: 'gender',
    isMulti: true,
    label: 'Gender',
    options: filterOptions.gender,
    value: null
  },
  airing_status: {
    id: 'airing_status',
    isMulti: true,
    label: 'Airing Status',
    options: filterOptions.airingStatus,
    value: null
  },
  exclude_deleted_characters: {
    id: 'exclude_deleted_characters',
    isToggle: true,
    label: 'Exclude Deleted Characters',
    options: filterOptions.excludeDeletedCharacters,
    value: null
  },
  show: {
    id: 'show',
    isAsync: true,
    isMulti: true,
    label: 'Show',
    loadOptions: algoliaApi.getShowFilterOptions,
    value: null
  },
  title: {
    id: 'title',
    isAsync: true,
    isMulti: true,
    label: 'Title(s)',
    loadOptions: algoliaApi.getTitleFilterOptions,
    value: null
  },
  platform: {
    id: 'platform',
    isAsync: true,
    isMulti: true,
    label: 'Platform(s)',
    loadOptions: algoliaApi.getPlatformFilterOptions,
    value: null
  },
  status: {
    id: 'status',
    isMulti: true,
    label: 'Status',
    options: filterOptions.status,
    value: null
  },
  movie: {
    id: 'movie',
    isAsync: true,
    isMulti: true,
    label: 'Movie',
    loadOptions: algoliaApi.getMovieFilterOptions,
    value: null
  },
  studio: {
    id: 'studio',
    isAsync: true,
    isMulti: true,
    label: 'Studio',
    loadOptions: algoliaApi.getStudioFilterOptions,
    value: null
  },
  episode: {
    id: 'episode',
    isAsync: true,
    isMulti: true,
    label: 'Episode',
    value: null
  },
  segments: {
    id: 'segments',
    isSegment: true,
    isPopulatedByClient: true,
    label: 'Saved Filters',
    value: null
  }
};
